import { useQuery } from "@tanstack/react-query";
import { authApi, type Me } from "../api/auth";

export function useSession() {
  return useQuery<Me, { status: number }>({
    queryKey: ["me"],
    queryFn: authApi.me,
    retry: false,
  });
}
